export default "__VITE_ASSET__BlLOp3iV__"